import { IResponse } from "models";

export enum ActionType {
  UPDATE_USER_DEPARTMENT = "action/UPDATE_USER_DEPARTMENT",
  UPDATE_USER_DEPARTMENT_SUCCESS = "action/UPDATE_USER_DEPARTMENT_SUCCESS",
  UPDATE_USER_DEPARTMENT_ERROR = "action/UPDATE_USER_DEPARTMENT_ERROR",
  UPDATE_USER_DEPARTMENT_RESET = "action/UPDATE_USER_DEPARTMENT_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IUpdateUserDepartmentPayload {
  id: number;
  c_department_id: number;
}

export interface UpdateUserDepartmentResponse extends IResponse {}
